import Homepage from '../../pages/HomePage';
import CarDetail from '../../pages/CarDetailPage';
import CarList from '../../pages/CarListPage';
import CertificationProgress from '../../pages/CertificationProgressPage';

export const ROUTES = {
  HOMEPAGE: {
    path: 'homepage',
    ToRender: Homepage,
  },
  CAR_LIST: {
    path: 'car-list',
    ToRender: CarList,
  },
  CAR_DETAIL: {
    path: 'car-detail',
    ToRender: CarDetail,
  },
  CERTIFICATION_PROGRESS: {
    path: 'certification-progress',
    ToRender: CertificationProgress,
  },
  START: {
    path: '',
    redirect: 'homepage',
  },
  NOMATCH: {
    path: '*',
    ToRender: Homepage,
  },
};
